"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CustomRouter = require("01_core/components/system/CustomRouter");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _GroupHisaiList = _interopRequireDefault(require("./components/GroupHisaiList"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class HomeDisplaySettingMain extends _react.default.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      intl,
      history
    } = this.props;
    const dispList = () => {
      return /*#__PURE__*/_react.default.createElement(_GroupHisaiList.default, null);
    };
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_SETTING_INFORMATION_DISP
      }),
      actions: [/*#__PURE__*/_react.default.createElement(_CButton.default, {
        autoWidth: true,
        negative: true,
        onClick: () => {
          history.push(_stringConsts.STRING_CONSTS.ROOT_PATH);
        }
      }, intl.formatMessage({
        id: _labelConsts.LABEL.CORE_TO_RETURN_HOME
      }))]
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, dispList()));
  }
}
var _default = exports.default = (0, _CustomRouter.withRouter)((0, _reactIntl.injectIntl)(HomeDisplaySettingMain));